/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as AdminLayoutRouteImport } from './routes/_adminLayout'
import { Route as LayoutIndexRouteImport } from './routes/_layout/index'
import { Route as LayoutSignoutRouteImport } from './routes/_layout/signout'
import { Route as LayoutSigninRouteImport } from './routes/_layout/signin'
import { Route as AdminLayoutAdminRouteImport } from './routes/_adminLayout/admin'
import { Route as AdminLayoutAdminIndexRouteImport } from './routes/_adminLayout/admin/index'
import { Route as LayoutViewAreaSlugRouteImport } from './routes/_layout/view.$areaSlug'
import { Route as LayoutViewAreaSlugIndexRouteImport } from './routes/_layout/view.$areaSlug.index'
import { Route as AdminLayoutAdminAreasIndexRouteImport } from './routes/_adminLayout/admin/areas/index'
import { Route as AdminLayoutAdminAreasAreaSlugRouteImport } from './routes/_adminLayout/admin/areas.$areaSlug'
import { Route as AdminLayoutAdminAreasAreaSlugIndexRouteImport } from './routes/_adminLayout/admin/areas.$areaSlug/index'
import { Route as LayoutViewAreaSlugViewerTypeSubjectSlugRouteImport } from './routes/_layout/view.$areaSlug.$viewerType.$subjectSlug'
import { Route as AdminLayoutAdminAreasAreaSlugAclRouteImport } from './routes/_adminLayout/admin/areas.$areaSlug/acl'
import { Route as AdminLayoutAdminAreasAreaSlugSubjectsIndexRouteImport } from './routes/_adminLayout/admin/areas.$areaSlug/subjects.index'
import { Route as AdminLayoutAdminAreasAreaSlugSubjectsNewRouteImport } from './routes/_adminLayout/admin/areas.$areaSlug/subjects.new'
import { Route as AdminLayoutAdminAreasAreaSlugSubjectsSubjectSlugRouteImport } from './routes/_adminLayout/admin/areas.$areaSlug/subjects.$subjectSlug'

const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLayoutRoute = AdminLayoutRouteImport.update({
  id: '/_adminLayout',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSignoutRoute = LayoutSignoutRouteImport.update({
  id: '/signout',
  path: '/signout',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSigninRoute = LayoutSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => LayoutRoute,
} as any)
const AdminLayoutAdminRoute = AdminLayoutAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const AdminLayoutAdminIndexRoute = AdminLayoutAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminLayoutAdminRoute,
} as any)
const LayoutViewAreaSlugRoute = LayoutViewAreaSlugRouteImport.update({
  id: '/view/$areaSlug',
  path: '/view/$areaSlug',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutViewAreaSlugIndexRoute = LayoutViewAreaSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutViewAreaSlugRoute,
} as any)
const AdminLayoutAdminAreasIndexRoute =
  AdminLayoutAdminAreasIndexRouteImport.update({
    id: '/areas/',
    path: '/areas/',
    getParentRoute: () => AdminLayoutAdminRoute,
  } as any)
const AdminLayoutAdminAreasAreaSlugRoute =
  AdminLayoutAdminAreasAreaSlugRouteImport.update({
    id: '/areas/$areaSlug',
    path: '/areas/$areaSlug',
    getParentRoute: () => AdminLayoutAdminRoute,
  } as any)
const AdminLayoutAdminAreasAreaSlugIndexRoute =
  AdminLayoutAdminAreasAreaSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminLayoutAdminAreasAreaSlugRoute,
  } as any)
const LayoutViewAreaSlugViewerTypeSubjectSlugRoute =
  LayoutViewAreaSlugViewerTypeSubjectSlugRouteImport.update({
    id: '/$viewerType/$subjectSlug',
    path: '/$viewerType/$subjectSlug',
    getParentRoute: () => LayoutViewAreaSlugRoute,
  } as any)
const AdminLayoutAdminAreasAreaSlugAclRoute =
  AdminLayoutAdminAreasAreaSlugAclRouteImport.update({
    id: '/acl',
    path: '/acl',
    getParentRoute: () => AdminLayoutAdminAreasAreaSlugRoute,
  } as any)
const AdminLayoutAdminAreasAreaSlugSubjectsIndexRoute =
  AdminLayoutAdminAreasAreaSlugSubjectsIndexRouteImport.update({
    id: '/subjects/',
    path: '/subjects/',
    getParentRoute: () => AdminLayoutAdminAreasAreaSlugRoute,
  } as any)
const AdminLayoutAdminAreasAreaSlugSubjectsNewRoute =
  AdminLayoutAdminAreasAreaSlugSubjectsNewRouteImport.update({
    id: '/subjects/new',
    path: '/subjects/new',
    getParentRoute: () => AdminLayoutAdminAreasAreaSlugRoute,
  } as any)
const AdminLayoutAdminAreasAreaSlugSubjectsSubjectSlugRoute =
  AdminLayoutAdminAreasAreaSlugSubjectsSubjectSlugRouteImport.update({
    id: '/subjects/$subjectSlug',
    path: '/subjects/$subjectSlug',
    getParentRoute: () => AdminLayoutAdminAreasAreaSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof LayoutIndexRoute
  '/admin': typeof AdminLayoutAdminRouteWithChildren
  '/signin': typeof LayoutSigninRoute
  '/signout': typeof LayoutSignoutRoute
  '/view/$areaSlug': typeof LayoutViewAreaSlugRouteWithChildren
  '/admin/': typeof AdminLayoutAdminIndexRoute
  '/admin/areas/$areaSlug': typeof AdminLayoutAdminAreasAreaSlugRouteWithChildren
  '/admin/areas/': typeof AdminLayoutAdminAreasIndexRoute
  '/view/$areaSlug/': typeof LayoutViewAreaSlugIndexRoute
  '/admin/areas/$areaSlug/acl': typeof AdminLayoutAdminAreasAreaSlugAclRoute
  '/view/$areaSlug/$viewerType/$subjectSlug': typeof LayoutViewAreaSlugViewerTypeSubjectSlugRoute
  '/admin/areas/$areaSlug/': typeof AdminLayoutAdminAreasAreaSlugIndexRoute
  '/admin/areas/$areaSlug/subjects/$subjectSlug': typeof AdminLayoutAdminAreasAreaSlugSubjectsSubjectSlugRoute
  '/admin/areas/$areaSlug/subjects/new': typeof AdminLayoutAdminAreasAreaSlugSubjectsNewRoute
  '/admin/areas/$areaSlug/subjects/': typeof AdminLayoutAdminAreasAreaSlugSubjectsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof LayoutIndexRoute
  '/signin': typeof LayoutSigninRoute
  '/signout': typeof LayoutSignoutRoute
  '/admin': typeof AdminLayoutAdminIndexRoute
  '/admin/areas': typeof AdminLayoutAdminAreasIndexRoute
  '/view/$areaSlug': typeof LayoutViewAreaSlugIndexRoute
  '/admin/areas/$areaSlug/acl': typeof AdminLayoutAdminAreasAreaSlugAclRoute
  '/view/$areaSlug/$viewerType/$subjectSlug': typeof LayoutViewAreaSlugViewerTypeSubjectSlugRoute
  '/admin/areas/$areaSlug': typeof AdminLayoutAdminAreasAreaSlugIndexRoute
  '/admin/areas/$areaSlug/subjects/$subjectSlug': typeof AdminLayoutAdminAreasAreaSlugSubjectsSubjectSlugRoute
  '/admin/areas/$areaSlug/subjects/new': typeof AdminLayoutAdminAreasAreaSlugSubjectsNewRoute
  '/admin/areas/$areaSlug/subjects': typeof AdminLayoutAdminAreasAreaSlugSubjectsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_adminLayout': typeof AdminLayoutRouteWithChildren
  '/_layout': typeof LayoutRouteWithChildren
  '/_adminLayout/admin': typeof AdminLayoutAdminRouteWithChildren
  '/_layout/signin': typeof LayoutSigninRoute
  '/_layout/signout': typeof LayoutSignoutRoute
  '/_layout/': typeof LayoutIndexRoute
  '/_layout/view/$areaSlug': typeof LayoutViewAreaSlugRouteWithChildren
  '/_adminLayout/admin/': typeof AdminLayoutAdminIndexRoute
  '/_adminLayout/admin/areas/$areaSlug': typeof AdminLayoutAdminAreasAreaSlugRouteWithChildren
  '/_adminLayout/admin/areas/': typeof AdminLayoutAdminAreasIndexRoute
  '/_layout/view/$areaSlug/': typeof LayoutViewAreaSlugIndexRoute
  '/_adminLayout/admin/areas/$areaSlug/acl': typeof AdminLayoutAdminAreasAreaSlugAclRoute
  '/_layout/view/$areaSlug/$viewerType/$subjectSlug': typeof LayoutViewAreaSlugViewerTypeSubjectSlugRoute
  '/_adminLayout/admin/areas/$areaSlug/': typeof AdminLayoutAdminAreasAreaSlugIndexRoute
  '/_adminLayout/admin/areas/$areaSlug/subjects/$subjectSlug': typeof AdminLayoutAdminAreasAreaSlugSubjectsSubjectSlugRoute
  '/_adminLayout/admin/areas/$areaSlug/subjects/new': typeof AdminLayoutAdminAreasAreaSlugSubjectsNewRoute
  '/_adminLayout/admin/areas/$areaSlug/subjects/': typeof AdminLayoutAdminAreasAreaSlugSubjectsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/signin'
    | '/signout'
    | '/view/$areaSlug'
    | '/admin/'
    | '/admin/areas/$areaSlug'
    | '/admin/areas/'
    | '/view/$areaSlug/'
    | '/admin/areas/$areaSlug/acl'
    | '/view/$areaSlug/$viewerType/$subjectSlug'
    | '/admin/areas/$areaSlug/'
    | '/admin/areas/$areaSlug/subjects/$subjectSlug'
    | '/admin/areas/$areaSlug/subjects/new'
    | '/admin/areas/$areaSlug/subjects/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/signin'
    | '/signout'
    | '/admin'
    | '/admin/areas'
    | '/view/$areaSlug'
    | '/admin/areas/$areaSlug/acl'
    | '/view/$areaSlug/$viewerType/$subjectSlug'
    | '/admin/areas/$areaSlug'
    | '/admin/areas/$areaSlug/subjects/$subjectSlug'
    | '/admin/areas/$areaSlug/subjects/new'
    | '/admin/areas/$areaSlug/subjects'
  id:
    | '__root__'
    | '/_adminLayout'
    | '/_layout'
    | '/_adminLayout/admin'
    | '/_layout/signin'
    | '/_layout/signout'
    | '/_layout/'
    | '/_layout/view/$areaSlug'
    | '/_adminLayout/admin/'
    | '/_adminLayout/admin/areas/$areaSlug'
    | '/_adminLayout/admin/areas/'
    | '/_layout/view/$areaSlug/'
    | '/_adminLayout/admin/areas/$areaSlug/acl'
    | '/_layout/view/$areaSlug/$viewerType/$subjectSlug'
    | '/_adminLayout/admin/areas/$areaSlug/'
    | '/_adminLayout/admin/areas/$areaSlug/subjects/$subjectSlug'
    | '/_adminLayout/admin/areas/$areaSlug/subjects/new'
    | '/_adminLayout/admin/areas/$areaSlug/subjects/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AdminLayoutRoute: typeof AdminLayoutRouteWithChildren
  LayoutRoute: typeof LayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_adminLayout': {
      id: '/_adminLayout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AdminLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/signout': {
      id: '/_layout/signout'
      path: '/signout'
      fullPath: '/signout'
      preLoaderRoute: typeof LayoutSignoutRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/signin': {
      id: '/_layout/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof LayoutSigninRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_adminLayout/admin': {
      id: '/_adminLayout/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminLayoutAdminRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/_adminLayout/admin/': {
      id: '/_adminLayout/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminLayoutAdminIndexRouteImport
      parentRoute: typeof AdminLayoutAdminRoute
    }
    '/_layout/view/$areaSlug': {
      id: '/_layout/view/$areaSlug'
      path: '/view/$areaSlug'
      fullPath: '/view/$areaSlug'
      preLoaderRoute: typeof LayoutViewAreaSlugRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/view/$areaSlug/': {
      id: '/_layout/view/$areaSlug/'
      path: '/'
      fullPath: '/view/$areaSlug/'
      preLoaderRoute: typeof LayoutViewAreaSlugIndexRouteImport
      parentRoute: typeof LayoutViewAreaSlugRoute
    }
    '/_adminLayout/admin/areas/': {
      id: '/_adminLayout/admin/areas/'
      path: '/areas'
      fullPath: '/admin/areas/'
      preLoaderRoute: typeof AdminLayoutAdminAreasIndexRouteImport
      parentRoute: typeof AdminLayoutAdminRoute
    }
    '/_adminLayout/admin/areas/$areaSlug': {
      id: '/_adminLayout/admin/areas/$areaSlug'
      path: '/areas/$areaSlug'
      fullPath: '/admin/areas/$areaSlug'
      preLoaderRoute: typeof AdminLayoutAdminAreasAreaSlugRouteImport
      parentRoute: typeof AdminLayoutAdminRoute
    }
    '/_adminLayout/admin/areas/$areaSlug/': {
      id: '/_adminLayout/admin/areas/$areaSlug/'
      path: '/'
      fullPath: '/admin/areas/$areaSlug/'
      preLoaderRoute: typeof AdminLayoutAdminAreasAreaSlugIndexRouteImport
      parentRoute: typeof AdminLayoutAdminAreasAreaSlugRoute
    }
    '/_layout/view/$areaSlug/$viewerType/$subjectSlug': {
      id: '/_layout/view/$areaSlug/$viewerType/$subjectSlug'
      path: '/$viewerType/$subjectSlug'
      fullPath: '/view/$areaSlug/$viewerType/$subjectSlug'
      preLoaderRoute: typeof LayoutViewAreaSlugViewerTypeSubjectSlugRouteImport
      parentRoute: typeof LayoutViewAreaSlugRoute
    }
    '/_adminLayout/admin/areas/$areaSlug/acl': {
      id: '/_adminLayout/admin/areas/$areaSlug/acl'
      path: '/acl'
      fullPath: '/admin/areas/$areaSlug/acl'
      preLoaderRoute: typeof AdminLayoutAdminAreasAreaSlugAclRouteImport
      parentRoute: typeof AdminLayoutAdminAreasAreaSlugRoute
    }
    '/_adminLayout/admin/areas/$areaSlug/subjects/': {
      id: '/_adminLayout/admin/areas/$areaSlug/subjects/'
      path: '/subjects'
      fullPath: '/admin/areas/$areaSlug/subjects/'
      preLoaderRoute: typeof AdminLayoutAdminAreasAreaSlugSubjectsIndexRouteImport
      parentRoute: typeof AdminLayoutAdminAreasAreaSlugRoute
    }
    '/_adminLayout/admin/areas/$areaSlug/subjects/new': {
      id: '/_adminLayout/admin/areas/$areaSlug/subjects/new'
      path: '/subjects/new'
      fullPath: '/admin/areas/$areaSlug/subjects/new'
      preLoaderRoute: typeof AdminLayoutAdminAreasAreaSlugSubjectsNewRouteImport
      parentRoute: typeof AdminLayoutAdminAreasAreaSlugRoute
    }
    '/_adminLayout/admin/areas/$areaSlug/subjects/$subjectSlug': {
      id: '/_adminLayout/admin/areas/$areaSlug/subjects/$subjectSlug'
      path: '/subjects/$subjectSlug'
      fullPath: '/admin/areas/$areaSlug/subjects/$subjectSlug'
      preLoaderRoute: typeof AdminLayoutAdminAreasAreaSlugSubjectsSubjectSlugRouteImport
      parentRoute: typeof AdminLayoutAdminAreasAreaSlugRoute
    }
  }
}

interface AdminLayoutAdminAreasAreaSlugRouteChildren {
  AdminLayoutAdminAreasAreaSlugAclRoute: typeof AdminLayoutAdminAreasAreaSlugAclRoute
  AdminLayoutAdminAreasAreaSlugIndexRoute: typeof AdminLayoutAdminAreasAreaSlugIndexRoute
  AdminLayoutAdminAreasAreaSlugSubjectsSubjectSlugRoute: typeof AdminLayoutAdminAreasAreaSlugSubjectsSubjectSlugRoute
  AdminLayoutAdminAreasAreaSlugSubjectsNewRoute: typeof AdminLayoutAdminAreasAreaSlugSubjectsNewRoute
  AdminLayoutAdminAreasAreaSlugSubjectsIndexRoute: typeof AdminLayoutAdminAreasAreaSlugSubjectsIndexRoute
}

const AdminLayoutAdminAreasAreaSlugRouteChildren: AdminLayoutAdminAreasAreaSlugRouteChildren =
  {
    AdminLayoutAdminAreasAreaSlugAclRoute:
      AdminLayoutAdminAreasAreaSlugAclRoute,
    AdminLayoutAdminAreasAreaSlugIndexRoute:
      AdminLayoutAdminAreasAreaSlugIndexRoute,
    AdminLayoutAdminAreasAreaSlugSubjectsSubjectSlugRoute:
      AdminLayoutAdminAreasAreaSlugSubjectsSubjectSlugRoute,
    AdminLayoutAdminAreasAreaSlugSubjectsNewRoute:
      AdminLayoutAdminAreasAreaSlugSubjectsNewRoute,
    AdminLayoutAdminAreasAreaSlugSubjectsIndexRoute:
      AdminLayoutAdminAreasAreaSlugSubjectsIndexRoute,
  }

const AdminLayoutAdminAreasAreaSlugRouteWithChildren =
  AdminLayoutAdminAreasAreaSlugRoute._addFileChildren(
    AdminLayoutAdminAreasAreaSlugRouteChildren,
  )

interface AdminLayoutAdminRouteChildren {
  AdminLayoutAdminIndexRoute: typeof AdminLayoutAdminIndexRoute
  AdminLayoutAdminAreasAreaSlugRoute: typeof AdminLayoutAdminAreasAreaSlugRouteWithChildren
  AdminLayoutAdminAreasIndexRoute: typeof AdminLayoutAdminAreasIndexRoute
}

const AdminLayoutAdminRouteChildren: AdminLayoutAdminRouteChildren = {
  AdminLayoutAdminIndexRoute: AdminLayoutAdminIndexRoute,
  AdminLayoutAdminAreasAreaSlugRoute:
    AdminLayoutAdminAreasAreaSlugRouteWithChildren,
  AdminLayoutAdminAreasIndexRoute: AdminLayoutAdminAreasIndexRoute,
}

const AdminLayoutAdminRouteWithChildren =
  AdminLayoutAdminRoute._addFileChildren(AdminLayoutAdminRouteChildren)

interface AdminLayoutRouteChildren {
  AdminLayoutAdminRoute: typeof AdminLayoutAdminRouteWithChildren
}

const AdminLayoutRouteChildren: AdminLayoutRouteChildren = {
  AdminLayoutAdminRoute: AdminLayoutAdminRouteWithChildren,
}

const AdminLayoutRouteWithChildren = AdminLayoutRoute._addFileChildren(
  AdminLayoutRouteChildren,
)

interface LayoutViewAreaSlugRouteChildren {
  LayoutViewAreaSlugIndexRoute: typeof LayoutViewAreaSlugIndexRoute
  LayoutViewAreaSlugViewerTypeSubjectSlugRoute: typeof LayoutViewAreaSlugViewerTypeSubjectSlugRoute
}

const LayoutViewAreaSlugRouteChildren: LayoutViewAreaSlugRouteChildren = {
  LayoutViewAreaSlugIndexRoute: LayoutViewAreaSlugIndexRoute,
  LayoutViewAreaSlugViewerTypeSubjectSlugRoute:
    LayoutViewAreaSlugViewerTypeSubjectSlugRoute,
}

const LayoutViewAreaSlugRouteWithChildren =
  LayoutViewAreaSlugRoute._addFileChildren(LayoutViewAreaSlugRouteChildren)

interface LayoutRouteChildren {
  LayoutSigninRoute: typeof LayoutSigninRoute
  LayoutSignoutRoute: typeof LayoutSignoutRoute
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutViewAreaSlugRoute: typeof LayoutViewAreaSlugRouteWithChildren
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutSigninRoute: LayoutSigninRoute,
  LayoutSignoutRoute: LayoutSignoutRoute,
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutViewAreaSlugRoute: LayoutViewAreaSlugRouteWithChildren,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AdminLayoutRoute: AdminLayoutRouteWithChildren,
  LayoutRoute: LayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
